import { createFileRoute } from "@tanstack/react-router";

function Index() {
    return <div />;
}

export const Route = createFileRoute("/")({
    component: Index,
});
